/**
 * @summary Slider thumbnail item preact component.
 */

import { h, Component } from 'preact';
import decode from '../html-decode';

/**
 * @summary Slider thumbnail item preact component.
 *
 * @class
 * @extends {Component}
 */
export default class SliderThumbsThumb extends Component {
	constructor( props ) {
		super( props );

		this.handleClick = this.handleClick.bind( this );
		this.setRef = this.setRef.bind( this );
	}

	/**
	 * @summary Returns classes for this element.
	 *
	 * @returns {string} The HTML class attribute string value.
	 */
	classes() {
		const additionalClasses = this.props.classes ? ` ${this.props.classes}` : '';
		const activeClass = this.props.active ? ' is-active' : '';

		return `woocommerce-loop-product${activeClass}${additionalClasses}`;
	}

	/**
	 * @summary Handles a click on the thumbnail element.
	 *
	 * @listens document:click
	 *
	 * @param {MouseEvent} event The click event.
	 */
	handleClick( event ) {
		event.preventDefault();

		if ( typeof this.props.handleClick === 'function' ) {
			this.props.handleClick( this.props.index );
		}
	}

	/**
	 * @summary Set reference for the button DOM element of this component.
	 *
	 * @param {HTMLElement} element The button DOM element.
	 */
	setRef( element ) {
		if ( typeof this.props.onRef === 'function' ) {
			this.props.onRef( element, this.props.index );
		}
	}

	render({ title, thumb }) {
		thumb.class += ' woocommerce-loop-product__thumbnail';

		return (
			<li>
				<button class={this.classes()} onClick={this.handleClick} ref={this.setRef}>
					<div class="woocommerce-loop-product__thumbnail-wrapper">
						<img {...thumb} />
					</div>
					<h2 class="woocommerce-loop-product__title">{decode( title )}</h2>
				</button>
			</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/SliderThumbsThumb.js